module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":{"employee":"Editing is disabled because the employee is no longer with the company"}}}')
  delete Component.options._Ctor
}
